import { branding, Colour_Tournament, PushOver } from "./Utils";

export class KickMap {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "KickMap";
    this.scene = "KickMap";
    this.data = [];
    this.page = 7062;
  }

  async preview({ options }) {
    this.onAir = false;
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = Colour_Tournament({ game: options.game, xml });
      xml = branding({ game: options.game, team: options.team, xml });
      xml = PushOver({ push_over: options.push_up, xml });

      xml.payload.field.find((item) => {
        return item.attr.name === "0000102";
      }).value =
        options.team?.variables?.alt_badge ||
        options.team?.variables?.badge ||
        "";


      xml.payload.field.find((item) => {
        return item.attr.name === "0000103";
      }).value = options.player.first_name || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0000104";
      }).value = options.player.last_name || "";
      let kick_string = ''

      options.kicks?.map((kick, index) => {
        kick.statname = kick?.statname ?? kick?.StatName;
        kick.nX = kick?.nX ?? kick?.Nx;
        kick.nY = kick?.nY ?? kick?.Ny;
        const pitchX = 100 - parseInt((kick?.nX / 1000) * 100);
        const pitchY = parseInt(((kick?.nY - 350) / 350) * 34);
        let type = '';
        if (kick?.KickToCome) {
          type = 'KickCurrent'
        } else {
          type = kick?.statname?.replace('Conversion-Missed', 'KickOffTarget')?.replace('Conversion-Made', 'KickOnTarget')?.replace('Penalty Shot-Made', 'KickOnTarget')?.replace('Penalty Shot-Missed', 'KickOffTarget').replace("conversion missed", 'KickOffTarget')?.replace("conversion made", 'KickOnTarget')?.replace("penalty shot made", 'KickOnTarget')?.replace(
"penalty shot missed", 'KickOffTarget');
        }
        kick_string += index + ',' + pitchX + ',' + pitchY + ',' + type + '\n'
      })

      xml.payload.field.find((item) => {
        return item.attr.name === "0101";
      }).value = kick_string;


      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
